import React from 'react';
import PropTypes from 'prop-types';

import CardBody from '../CardBody/CardBody';
import QuestionProgressHeader from '../QuestionProgressHeader/QuestionProgressHeader';

import {
  PlaythroughCardContainer,
} from './PlaythroughCard.styles';

const PlaythroughCard = ({ children }) => {
  return (
    <PlaythroughCardContainer>
      <QuestionProgressHeader />
      <CardBody>
        { children }
      </CardBody>
    </PlaythroughCardContainer>
  );
};

PlaythroughCard.propTypes = {
  children: PropTypes.any,
};

export default PlaythroughCard;
